import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const billingDetailMenuRegistry = {
    core_billingDetail: {
        label: "Billing Detail",
        link: PAGE_URL.BILLING_DETAIL_PAGE,
        key: PAGE_URL.BILLING_DETAIL_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default billingDetailMenuRegistry;
